import { Trans, useLingui } from "@lingui/react/macro";

import { ToggleGroup, ToggleGroupItem } from "@/shared/ui/toggle-group";

import { FRIENDS_PERIODS, type FriendsPeriod } from "../../model/FRIENDS_PERIODS";

type FriendsHeaderProps = {
  period: FriendsPeriod;
  onPeriodChange: (period: FriendsPeriod) => void;
};

// Заголовок экрана и период: неделя, месяц, всё время.
export const FriendsHeader = ({ period, onPeriodChange }: FriendsHeaderProps) => {
  const { t } = useLingui();
  const labels: Record<FriendsPeriod, string> = {
    week: t`Week`,
    month: t`Month`,
    all: t`All time`,
  };
  return (
    <div className="flex flex-wrap items-end justify-between gap-3">
      <div className="flex flex-col gap-1">
        <h1 className="font-display text-[34px] leading-tight">
          <Trans>You and friends</Trans>
        </h1>
        <p className="text-sm text-muted">
          <Trans>
            Steam friends who also use Relock. Only regular matches count, without Street Brawl.
          </Trans>
        </p>
      </div>
      <ToggleGroup
        type="single"
        aria-label={t`Period`}
        value={period}
        onValueChange={(value) => {
          const next = FRIENDS_PERIODS.find((option) => option === value);
          if (next !== undefined) {
            onPeriodChange(next);
          }
        }}
      >
        {FRIENDS_PERIODS.map((option) => (
          <ToggleGroupItem key={option} value={option}>
            {labels[option]}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    </div>
  );
};
